import { QueryFactory } from '@lmt/shared-types';
import { useModal } from '@lmt/unicorn-shared/app/components/common/ui-kit/modal/useModal';
import { APP_VERSION } from '@lmt/unicorn-shared/app/constants/constants';
import { pages } from '@lmt/unicorn-shared/app/constants/sharedRoutes';
import { logOut } from '@lmt/unicorn-shared/app/features/auth/operations';
import { isElectron } from '@lmt/unicorn-shared/app/helpers/common';
import { checkAppVersionCompatibility } from '@lmt/unicorn-shared/app/helpers/version-helper';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/*
Pings backend every minute to refresh the token.
 */
export const PingBackendComponent = () => {
  const { error: queryError, data: version } =
    QueryFactory.VersionQuery.useVersionAuthenticatedQuery({
      refetchInterval: 60 * 1000,
      refetchIntervalInBackground: true,
      throwOnError: false,
    });

  const modals = useModal();
  const i18next = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (queryError) {
      console.error('versionAuthenticated errored', queryError);
    }

    if (!isElectron() || APP_VERSION === '0.0.0.DEV') {
      return;
    }

    if (version && !checkAppVersionCompatibility(APP_VERSION, version)) {
      modals
        .showError({
          text: i18next.t('login_form.app_version_incompatible_full_message', {
            appVersion: APP_VERSION,
            apiVersion: version,
          }),
        })
        .then(() => {
          logOut();
          navigate(pages.home.link());
        });
    }
  }, [queryError, version]);

  return null;
};
